export default "__VITE_ASSET__bc66fc61__"